export default __webpack_public_path__ + "static/media/cn-xj.5a220189.svg";